﻿import $ from "jquery";
import ko from "knockout";

import ProductModel from "./ProductModel";

export default class TabModel {
	constructor(tab, options, firstRun) {
		const _ = this;

		_.options = options;

		_.id = tab.id;
		_.sysName = tab.sysName;
		_.$tab = $(`#${options.entryPointId} .ccs-logo-tab`);

		_.name = tab.name;
		_.fields = tab.fields;

		_.tabProducts = _.mapProducts(tab.products);

		_.page = ko.observable(0);

		_.initPageSize = tab.pageSize;
		_.pageSize = ko.observable(tab.pageSize || 3);

		_.totalPages = ko.pureComputed(() => Math.ceil(_.subcategoryProducts().length / _.pageSize()));

		_.subcategories = ko.observableArray(
			tab.subcategories.map(sub => {
				sub.uniqueId = "ccschk" + _.options.entryPointId + sub.id; //for clickable tag label
				sub.checked = ko.observable(true);
				return sub;
			}));

		_.dropdownVisible = ko.observable(false);

		_.disabledSearch = _.subcategories().length === 1 ? true : false;

		_.activeSubs = ko.pureComputed(() => _.subcategories().filter(x => x.checked()));

		_.activeSubs.subscribe(() => { _.page(0); _.logEvent() });

		_.subcategoryProducts = ko.pureComputed(() => {
			if (_.subcategories().length === _.activeSubs().length) {
				return _.tabProducts;
			}

			return _.tabProducts.filter(prod => _.activeSubs().some(s => s.id === prod().info.hpUpSellsSubcategory));
		});

		_.products = ko.pureComputed(() => {
			const products = _.subcategoryProducts().slice(_.startIndex(), _.endIndex());

			if (!_.options.parsingPriceJs) {
				return products;
			}

			// Price should be parsed after the hover is shown.
			if (!firstRun || _.options.inline) {
				_.parsePrice(products);
			}

			firstRun = false;

			return products;
		});

		_.startIndex = ko.pureComputed(() => _.page() * _.pageSize());

		_.endIndex = ko.pureComputed(() => Math.min(_.startIndex() + _.pageSize(), _.subcategoryProducts().length));

		_.pageInfo = ko.pureComputed(() => {
			return ccs_util.stringFormat(
				_.options.texts.pageInfo,
				(_.startIndex() + 1) + "-" + _.endIndex(),
				_.subcategoryProducts().length);
		});

		_.hasNext = ko.pureComputed(() => _.page() + 1 >= _.totalPages());
		_.hasPrev = ko.pureComputed(() => _.page() - 1 < 0);

		_.footnotes = tab.footnotes;
		_.footnotesWidth = ko.pureComputed(() => _.products().length + 1);

		_.updatePageSize();

		_.subsAssets = ko.pureComputed(() => {
			let current,
				result = [];
			ko.utils.arrayForEach(_.products(), (prod) => {
				const candidate = prod().info.hpUpSellsSubcategory;
				if (current && current.id !== candidate) {
					current = null;
				}

				let description = "";

				const subCategory = _.subcategories().filter(s => s.id === candidate);
				if (subCategory.length !== 0) {
					description = subCategory[0].description;
				}

				if (!current) {
					current = {
						id: candidate,
						name: description,
						count: 0
					};

					result.push(current);
				}

				current.count++;
			});

			return result;
		});

		_.showSubs = ko.pureComputed(() => _.subsAssets().some(s => s.name));

		_.logEvent = () => {
			const subNames = _.activeSubs().map(sub => sub.name);
			const clientParams = { ActionContext: JSON.stringify(subNames) };

			ccs_cc_log.dispatchEvent(_.options.eventCall, clientParams);
		};
	}

	disableFilter(item) {
		return this.activeSubs().length === 1 && item.checked();
	}

	toggleDropdown() {
		this.dropdownVisible(!this.dropdownVisible());
		this.$tab.find(".ccs-logo-subcategories").slideToggle();
	}

	parsePrices() {
		this.parsePrice(this.products());
	}

	parsePrice(products) {
		$.each(products, (i, product) => {
			product().parsePrice();
		});
	}

	nextPage() {
		this.page(this.page() + 1);
	}

	prevPage() {
		this.page(this.page() - 1);
	}

	hasValues(property) {
		const products = this.products();

		for (let i = 0; i < products.length; i++) {
			if (products[i]().info[property]) {
				return true;
			}
		}

		return false;
	}

	mapProducts(products) {
		return products.map(product => ko.observable(new ProductModel(product, this.options)));
	}

	updatePageSize() {
		const _ = this, $tab = _.$tab;

		if (!_.options.inline) {
			return;
		}

		if (!$tab.is(":visible")) {
			setTimeout(() => _.updatePageSize(), 300);
			return;
		}

		const tableWidth = $tab.width();
		const firstColumnWidth = $tab.find("th:first-child").outerWidth();

		const targetWidth = _.options.columnWidth || 125;

		const pageSize =
			Math.max(1,
				Math.min(
					_.initPageSize || _.tabProducts.length,
					Math.floor((tableWidth - firstColumnWidth) / targetWidth))
			);

		if (_.pageSize() !== pageSize) {
			_.page(0);
			_.pageSize(pageSize);
		}
	}
}